import styled from 'styled-components';

export const Container = styled.div`
  .row {
    height: 350px;
    width: 100%;
    border-radius: 22px;

    @media (max-width: 1040px) {
      width: 80%;
    }
    @media (max-width: 720px) {
      width: 100%;
    }
  }
`;
